import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "hamburger",
  "use": "hamburger-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"hamburger\"><path d=\"M0 3c0-.552.512-1 1.143-1h13.714C15.488 2 16 2.448 16 3s-.512 1-1.143 1H1.143C.512 4 0 3.552 0 3zm0 5c0-.552.512-1 1.143-1h13.714C15.488 7 16 7.448 16 8s-.512 1-1.143 1H1.143C.512 9 0 8.552 0 8zm1.143 4C.512 12 0 12.448 0 13s.512 1 1.143 1h13.714c.631 0 1.143-.448 1.143-1s-.512-1-1.143-1H1.143z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol